import { render, staticRenderFns } from "./jing-yu-more.vue?vue&type=template&id=358067e4&scoped=true"
import script from "./jing-yu-more.vue?vue&type=script&lang=js"
export * from "./jing-yu-more.vue?vue&type=script&lang=js"
import style0 from "./jing-yu-more.vue?vue&type=style&index=0&id=358067e4&prod&lang=less&scoped=true"
import style1 from "./jing-yu-more.vue?vue&type=style&index=1&id=358067e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358067e4",
  null
  
)

export default component.exports